




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuctionListing, filterTypes } from '@/AuctionListing'
import { TokenUser } from '@/TokenUser'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'
import { auctionStatus } from '@/Auction';

@Component({
  name: 'AuctionListingListComponent',
  components: { Plotly }
})
export default class AuctionListingListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: AuctionListing

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  @Prop({ default: false })
  public showDiscount: boolean

  @Prop({ default: false })
  public flowAddress: string

  @Prop()
  public filterUsed: filterTypes

  @Prop()
  public publicView: boolean

  // public reactive member variables available to the html template
  public SHOW_IMAGE = true
  public tick: number = 1                 // hacky way to force endTime to update every second

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get niceFeedbackRating(): string { return this.moment.sellerFeedbackRating ? this.moment.sellerFeedbackRating.toFixed(1) : "0.0" }

  public get getClassNameBasedOnStatusAndBids(): string {
    if (this.publicView || this.moment.auction.status === auctionStatus.Open || this.filterUsed === filterTypes.Lost || this.filterUsed === filterTypes.Unsold) {
      if (this.moment.auction.numBids) return "hasBids"
      return "zeroBids" 
    }
    if (this.moment.auction.status === auctionStatus.Canceled) return 'negative'
    if (this.filterUsed === filterTypes.Won || this.filterUsed === filterTypes.Sold) {
      if (this.moment.auction.whenFullfilled) return 'positive'
      return 'yellow'
    }
  }
  public get getAuctionStatusString(): string { 
    if (this.publicView || this.moment.auction.status === auctionStatus.Open || this.filterUsed === filterTypes.Live || this.filterUsed === filterTypes.Lost || this.filterUsed === filterTypes.Unsold) return `${this.moment.auction.numBids.toString()} bid${this.moment.auction.numBids === 1 ? '' : 's'}`
    if (this.moment.auction.status === auctionStatus.Canceled) return 'Canceled'
    if (this.filterUsed === filterTypes.Won || this.filterUsed === filterTypes.Sold) {
      if (this.moment.auction.whenFullfilled) return 'Fulfilled'
      return 'Not yet fulfilled'
    }
  }
  public get getClassNameBasedOnUserStatus(): string {
    if (!this.flowAddress) return "neutral"
    if (utils_topshot.withPrefix(this.moment.auction.seller) === utils_topshot.withPrefix(this.flowAddress)) return "lightblue"
    if (!this.moment.usersHighestBid) return "neutral"
    if (utils_topshot.withPrefix(this.moment.auction.highestBidder) === utils_topshot.withPrefix(this.flowAddress)) return "positive"
    return "negative"
  }
  public get getUserStatusString(): string {
    if (!this.flowAddress) return ""
    if (utils_topshot.withPrefix(this.moment.auction.seller) === utils_topshot.withPrefix(this.flowAddress)) return "Seller"
    if (!this.moment.usersHighestBid) return ""
    if (utils_topshot.withPrefix(this.moment.auction.highestBidder) === utils_topshot.withPrefix(this.flowAddress)) {
      if (this.moment.auction.endedSuccessfully) return 'Winner'
      return "High bidder"
    }
    return "Outbid"
  }
  public get isTouchDevice(): boolean { return utils.isTouchDevice() }

  public getNicePriceString(number): string { return utils_topshot.getNicePriceString(number)}
  public getNicePossibleDecimalPriceString(number): string { return utils_topshot.getNicePossibleDecimalPriceString(number)}

  public getBidButtonName(): string {
    if (this.moment.auction.status !== auctionStatus.Open) return 'Ended'
    if (this.user && this.moment.auction.seller === this.user.linkedFlowAddress) return 'View'
    return 'Bid'
  }
  public getBidButtonVariant(): string {
    if (this.user && this.user && this.moment.auction.seller === this.user.linkedFlowAddress) return 'info'
    return 'info'
  }

  public onBidOrView() {
    // tell AuctionListingComponent to popup auction popup
    this.$emit('viewAuction', this.moment)
  }

  public getNiceCollectorScore(score: number) {
    return utils_topshot.getNiceCollectorScore(score)
  }
  public getNiceAuctionScore(score: number) {
    return utils_topshot.getNiceAuctionScore(score)
  }

  public getClassNameBasedOnScore(score: number) {
    return utils_topshot.getClassNameBasedOnScore(score)
  }
  public getClassNameBasedOnAuctionScore(score: number) {
    return utils_topshot.getClassNameBasedOnAuctionScore(score)
  }

  public clickToTopShot() {
    const url: string = this.moment.getTopShotLink(true)
    if (url) window.open(url, "_blank"); 
  }

  // private, non-reactive member variables
  private timer

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // if less than 1 day left, do live countdown
    if (this.moment.auction) {
      const nowTimeMS: number = new Date().getTime()
      if (nowTimeMS - this.moment.auction.getCurrentEndDate().getTime() < 86400 * 1000) {
        this.timer = setInterval(function() {
          this.tick++
        }.bind(this), 1000)
      }
    }

  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

    if (this.timer) clearTimeout(this.timer)
    this.timer = null
  }

}
